import LevelingIcon from './component.jsx'
export default LevelingIcon
